import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';
import { UnitOfMeasureService } from '../proxy/general/controllers/unit-of-measure.service';

FieldBuilder.setNamespace('General');

export const TRUCKLOGIC_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('name', 'Entity.TruckLogic.Name')
    .required()
    .minLength(1)
    .maxLength(100)
    .build(),
  FieldBuilder
    .number('fromQuantity', 'Entity.TruckLogic.FromQuantity')
    .required()
    .decimal(2,10)
    .build(),
  FieldBuilder
    .number('untilQuanity', 'Entity.TruckLogic.UntilQuantity')
    .required()
    .decimal(2,10)
    .build(),
  FieldBuilder
    .foreignKey('unitOfMeasureId', 'Entity.UnitOfMeasure', UnitOfMeasureService)
    .required()
    .displayFromNested('unitOfMeasure.name')
    .sortBy('unitOfMeasure.name')
    .build(),
];

export const TRUCKLOGIC_CONFIG = {
  entityName: 'TruckLogic',
  localizationKey: 'General::Entity.TruckLogic',
  fields: TRUCKLOGIC_FIELDS,
  permission: 'ControllingStructural.TruckLogics',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Controlling + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Structural + MENU_NAME_SUFFIX,
};
